// @flow

import styles from './JobHeader.less';
import React, { Component } from 'react';

import {
  Section,
  ScreenReaderOnly,
  Text,
  TextLink,
  Hidden,
  Rating
} from 'seek-style-guide/react';

import MoreJobsLink from '../MoreJobsLink/MoreJobsLink';
import JobTitle from '../JobTitle/JobTitle';
import NavLink from 'src/components/NavLink/NavLink';

export default class JobHeader extends Component<*> {
  props: ChaliceJobDetail;

  renderCompanyInfo() {
    const { companyReview, advertiser, isPrivateAdvertiser } = this.props;
    const { companyName, companyProfileUrl, companyTotalReviews } =
      companyReview || {};

    if (isPrivateAdvertiser) {
      return <Text small>{advertiser.description}</Text>;
    }

    const RatingDescription = companyReview && (
      <span>
        overall rating
        <Hidden mobile>
          {' ('}
          <NavLink
            data-automation="job-header-company-review-link"
            rel="nofollow"
            location={companyProfileUrl}
            component={TextLink}
            analytics="job-details-company-profile-top-clicked"
          >
            {`${companyTotalReviews} employee reviews`}
          </NavLink>
          {') '}
        </Hidden>
      </span>
    );

    return (
      <h2>
        <Hidden screen>Advertiser:&nbsp;</Hidden>
        <Text
          data-automation={
            companyName ? 'job-header-company-review-title' : 'advertiser-name'
          }
        >
          {companyName || advertiser.description}
        </Text>

        {companyReview && (
          <Rating
            className={styles.rating}
            rating={companyReview.companyOverallRating}
            description={RatingDescription}
          />
        )}

        <MoreJobsLink
          advertiser={advertiser}
          analytics="job-details-more-jobs-top-clicked"
          data-automation="job-details-header-more-jobs"
        />
      </h2>
    );
  }

  render() {
    const { title, isExpired } = this.props;

    return (
      <section aria-labelledby="jobHeader">
        <ScreenReaderOnly>
          <h2 id="jobHeader">Job Header</h2>
        </ScreenReaderOnly>
        <Section>
          <Text headline data-automation="job-detail-title">
            <JobTitle isExpired={isExpired} title={title} />
          </Text>
          {this.renderCompanyInfo()}
        </Section>
      </section>
    );
  }
}
